import {
  faBuildingColumns,
  faFileExport,
  faMoneyBillTransfer,
  faRightLeft,
} from "@fortawesome/free-solid-svg-icons";
import { formatAccount } from "../../../features/ValueFormater";

export function getTimeGreeting(name) {
  const hour = new Date().getHours();
  const label = hour < 12 ? "Good morning" : hour < 18 ? "Good afternoon" : "Good evening";
  return `${label}, ${name}!`;
}

export function buildDetailsTransactionId(row) {
  const rawId = String(row?.Transaction || "");
  const prefixedId = rawId.startsWith("ts") ? rawId : `ts${rawId}`;

  if (row?.IsBankAccountTransfer === 1) return prefixedId;
  if (row?.IsBankAccountTransfer === 2) return `rm${rawId}`;
  return rawId;
}

export function buildDetailsRequestId(row) {
  const baseId = buildDetailsTransactionId(row?.original || row);

  if (row?.method === "Quick Pay") return baseId;
  if (row?.isPayrollReference) return `${baseId}-3`;

  return baseId;
}

function formatApprovalAmount(row) {
  const values = [];

  if (row?.Amount !== null && row?.Amount !== undefined && row?.Amount !== "") {
    values.push(formatAccount(row.Amount || 0, row.CurrencyID || 1));
  }

  if (row?.Amount2) {
    values.push(formatAccount(row.Amount2, row.CurrencyID2 || 2));
  }

  return values.length ? values : ["-"];
}

function resolveApprovalMeta(row) {
  const method = String(row?.Method || "").toLowerCase();
  const description = String(row?.Description || "").toLowerCase();

  if (method.includes("card") || description.includes("card")) {
    return {
      iconSrc: "/Images/yool-card.svg",
      title: "Corporate Card",
      reviewLabel: "Review Request",
      tone: "blue",
      priority: "Medium Priority",
    };
  }

  if (row?.IsPayrollReference || method.includes("payroll")) {
    return {
      iconSrc: "/Images/action.svg",
      title: "Payroll approval",
      reviewLabel: "Review Payroll",
      tone: "orange",
      // priority: "High Priority",
    };
  }

  if (description.includes("statement") || method.includes("statement")) {
    return {
      icon: faFileExport,
      title: "Statement of Account Export Request",
      reviewLabel: "Review Request",
      tone: "purple",
      priority: "Medium Priority",
    };
  }

  if (Number(row?.IsBankAccountTransfer || 0) > 0) {
    return {
      icon: faBuildingColumns,
      title: "Pending Bank Transfer",
      reviewLabel: "Review Transfer",
      tone: "blue",
      // priority: "High Priority",
    };
  }

  if (method.includes("transfer")) {
    return {
      icon: faRightLeft,
      title: "Pending Transfers",
      reviewLabel: "Review Transfer",
      tone: "blue",
      // priority: "High Priority",
    };
  }

  return {
    icon: faMoneyBillTransfer,
    title: row?.Method || "Pending Approval",
    reviewLabel: "Review Request",
    tone: "blue",
    priority: "Medium Priority",
  };
}

export function normalizeDashboardApproval(row) {
  const meta = resolveApprovalMeta(row);

  return {
    id: `${row?.Transaction || row?.PaymentDate || row?.Description || "approval"}`,
    transaction: row?.Transaction || "",
    account: row?.Account || "-",
    paymentDate: row?.PaymentDate,
    description: row?.Description || "-",
    method: row?.Method || "-",
    amount: row?.Amount || 0,
    amount2: row?.Amount2 || null,
    currencyId: row?.CurrencyID || 1,
    currencyId2: row?.CurrencyID2 || null,
    typeId: Number(row?.TypeID ?? 0),
    externalTransferTypeItem: row?.eExternalTransferTypeItem || "",
    externalTransferCurrency: row?.ExternalTransferCurrency || "",
    isPayrollReference: Boolean(row?.IsPayrollReference),
    isBankAccountTransfer: Number(row?.IsBankAccountTransfer ?? 0),
    detailsTransactionId: buildDetailsTransactionId(row),
    title: meta.title,
    reviewLabel: meta.reviewLabel,
    icon: meta.icon,
    iconSrc: meta.iconSrc || "",
    tone: meta.tone,
    priority: meta.priority,
    formattedAmount: formatApprovalAmount(row),
    original: row,
  };
}

export function normalizeWelcomeDashboard(response) {
  const payload = response?.Payload || response || {};
  const pending = Array.isArray(payload?.TransactionsAwaitingApproval)
    ? payload.TransactionsAwaitingApproval
    : [];
  const dailySpent = Array.isArray(payload?.DailySpent) ? payload.DailySpent : [];

  return {
    transactionsAwaitingApproval: pending,
    dailySpent,
  };
}
